module.exports = __webpack_public_path__ + "static/media/cc-bobina3.c5940252.jpg";